import React from 'react';
import Drawer from '../../ui/drawer';
import { InstantQuoteForm } from './components/instant-quote-form';
import classes from './instant-quote-popup.scss';
export const InstantQuotePopupComponent = ({
  onClose,
  open,
  isLimitedEdition
}) => /*#__PURE__*/React.createElement(Drawer, {
  prerenderForCrawlers: true,
  onClose: onClose,
  headerTitle: "Instant quote",
  headerClassName: classes.header,
  dataDrawer: "InstantQuote",
  open: open,
  closeClassName: isLimitedEdition ? classes.orangeClose : ''
}, /*#__PURE__*/React.createElement(InstantQuoteForm, null));